import { ReactNode } from 'react';

const ConditionalWrapper: React.FC<ConditionalWrapperProps> = (props) => {
    return props.condition
        ? props.wrapper(props.children)
        : props.falsyWrapper
          ? props.falsyWrapper(props.children)
          : props.children;
};

export default ConditionalWrapper;

interface ConditionalWrapperProps {
    condition: boolean;
    wrapper(children: ReactNode): ReactNode;
    falsyWrapper?(children: ReactNode): ReactNode;
    children: ReactNode;
}
